import { render, staticRenderFns } from "./CompleteExam.vue?vue&type=template&id=bf0c118a"
import script from "./CompleteExam.vue?vue&type=script&lang=js"
export * from "./CompleteExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports